import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CombinedStates, AppDispatch } from 'core/types';
import './uploadedFileList.scss';
import { Attachment } from 'core/visitRequestForm/types';
import { CancelIcon, FileIcon } from 'components/Elements/CustomSVGIcon';
import { deleteAttachment } from 'core/visitRequestForm/visitRequestFormApi';
import { deleteAccessRequestAttachment } from 'core/accessRequestForm/accessRequestFormApi';
import { deleteGuardingRequestAttachment } from 'core/guardingRequestForm/guardingRequestFormApi';
import { useParams } from 'react-router-dom';

interface UploadedFileListProps {
    reduxSliceKey?: 'visitRequestForm' | 'accessRequestForm' | 'guardingRequestForm';
    attachmentKey?: 'attachments' | 'accessAttachments';
}

const UploadedFileList: FC<UploadedFileListProps> = ({ reduxSliceKey = 'visitRequestForm', attachmentKey = 'attachments' }) => {
    const getSliceState = (state: CombinedStates) => {
        if (reduxSliceKey === 'accessRequestForm') return state.accessRequestForm;
        if (reduxSliceKey === 'guardingRequestForm') return state.guardingRequestForm;
        return state.visitRequestForm;
    };
    const slice = useSelector(getSliceState);
    const { visitRequest } = slice;
    const { userData } = useSelector((state: CombinedStates) => state.user);
    const uploadedFiles = (attachmentKey === 'accessAttachments'
        ? slice.visitRequest?.accessAttachments
        : slice.visitRequest?.attachments) || [];

    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();

    const getFileDisplay = (file: Attachment) => {
        const handleRemove = () => {
            if (id && file.id) {
                if (reduxSliceKey === 'accessRequestForm') {
                    dispatch(deleteAccessRequestAttachment({ id, attachmentId: file.id }));
                } else if (reduxSliceKey === 'guardingRequestForm') {
                    dispatch(deleteGuardingRequestAttachment({ id, attachmentId: file.id }));
                } else {
                    dispatch(deleteAttachment({ id, attachmentId: file.id }));
                }
            }
        };

        return (
            <li className="uploaded-file-display" key={file.id}>
                <div className="icon-wrapper">
                    <FileIcon />
                    <span>{file.originalFilename}</span>
                </div>
                {userData.email === visitRequest.requester?.email && (
                    <div className="remove-file-button" onClick={handleRemove}>
                        <CancelIcon s="#C0D1D8" />
                    </div>
                )}
            </li>
        );
    };

    return <ul className="uploaded-files-list-container">{uploadedFiles.map((file: Attachment) => getFileDisplay(file))}</ul>;

};

export default UploadedFileList;
